module.exports = new __parcel__URL__("EMIT_story_card.5d1b9634.png").toString();